import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {rssFeedsList_template} from "../components/templates/rssFeedsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class rss_feed extends vnModule_knockoutJS {

    protected xhrs = []
    protected rssFeedsList: rssFeedsList_template

    buildContent(): Array<Element> {
        this.rssFeedsList = new rssFeedsList_template("rssFeedsList", this.viewModel, this)
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("RSS Feeds");
        return [this.rssFeedsList.build()];
    }

    fillPage() {
        this.getRssFeedsData()
    }

    protected getModuleName(): string {
        return "rss_feed";
    }

    public getRssFeedsData() {

        if (this.xhrs['get_rssFeedsData']) {
            this.xhrs['get_rssFeedsData'].cancelAndReset()
        }

        this.loadingIn(this.rssFeedsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let url: string = `/api/brand/${idBrand}/rss-feeds/get/`;
        let params = [];
        this.xhrs['get_rssFeedsData'] = new XMLHttpRequestHandler(url, params, this);
        this.xhrs['get_rssFeedsData'].onReadyStateFunction = this.ongetRSSFeedsDataReturn;
        this.xhrs['get_rssFeedsData'].execute();
    }

    private ongetRSSFeedsDataReturn(req, obj: this) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const executionTimeInMilliseconds = new Date().getTime() - req.requestStartTime;
                const executionTimeInSeconds = executionTimeInMilliseconds / 1000;
                const executionTime = Math.round(executionTimeInSeconds * 100) / 100;

                let responseParsed = JSON.parse(req.request.response);

                const {rssFeedsViewModes, permissions} = responseParsed.data
                obj.rssFeedsList.setRSSFeeds(rssFeedsViewModes)

                obj.rssFeedsList.getTemplateViewModel()
                    .rssFeedsViewModes.sort((l, r) => {
                    return l.value == r.value ? 0 : l.value < r.value ? -1 : 1
                })
                obj.rssFeedsList.setPermissions(permissions)
                obj.rssFeedsList.resultInfos.setExecutionTime(executionTime);
                obj.rssFeedsList.resultInfos.setNbPages(1);
                obj.rssFeedsList.resultInfos.setNbResults(rssFeedsViewModes.length);
            });
            obj.loadingOut(obj.rssFeedsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    public saveRssFeedsViewModeData() {
        if (this.xhrs['save_rssFeedsData']) {
            this.xhrs['save_rssFeedsData'].cancelAndReset()
        }
        this.loadingIn(this.rssFeedsList.builtTemplate.children.namedItem("list-results"));

        const rssFeedsViewModesObj = ko.toJSON(this.rssFeedsList.getTemplateViewModel().rssFeedsViewModes());

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let url: string = `/api/brand/${idBrand}/rss-feeds/save/`;
        let params = [["rssFeedsViewModes", rssFeedsViewModesObj]];
        this.xhrs['save_rssFeedsData'] = new XMLHttpRequestHandler(url, params, this);
        this.xhrs['save_rssFeedsData'].mode = XMLHttpRequestHandler_requestType.POST
        this.xhrs['save_rssFeedsData'].onReadyStateFunction = this.onSaveRSSFeedsDataReturn;
        this.xhrs['save_rssFeedsData'].execute();
    }

    private onSaveRSSFeedsDataReturn(req, obj: this) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (req.request.readyState == 4) {
                    if (req.request.status == 200) {
                        // obj.getRssFeedsData();

                        obj.loadingOut(obj.rssFeedsList.builtTemplate.children.namedItem("list-results"));

                        const {type, message} = responseParsed;
                        obj.showNotification(type, message);

                    } else {
                        obj.getRssFeedsData();
                        obj.loadingOut(obj.rssFeedsList.builtTemplate.children.namedItem("list-results"));
                        obj.showErrorNotification();
                    }
                }

            });

        }
    }

    private showNotification(type, message) {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }

    private showErrorNotification(type = "error", message = "Something went wrong!") {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }
}


// WEBPACK FOOTER //
// ./js/modules/rss_feed.ts